import React from 'react'
import PropTypes from 'prop-types'
import { StyledSvgContainer, StyledSvg } from './styles'

const createFluidObj = src => ({
  src,
  aspectRatio: 0.8,
})

const Icon = ({ icon, customIcon, width, fill, ...props }) => {
  switch (icon) {
    case 'Support':
      return (
        <svg
          data-testid="support-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="73.743"
          height="74.001"
          viewBox="0 0 73.743 74.001"
        >
          <g id="prefix__support" transform="translate(-.894)">
            <path
              id="prefix__Path_98"
              d="M246.492 9.4a1.456 1.456 0 0 0 1.456-1.456V1.456a1.456 1.456 0 1 0-2.911 0v6.492a1.456 1.456 0 0 0 1.455 1.452z"
              fill="#0072ce"
              data-name="Path 98"
              transform="translate(-208.855)"
            />
            <path
              id="prefix__Path_99"
              d="M73.217 120.286l-2.571-2.564a4.874 4.874 0 0 0-5.768-.823l-4.846-4.84.236-.236a5.052 5.052 0 0 0 0-7.133 5 5 0 0 0-2.534-1.37 5.083 5.083 0 0 0 .2-1.416 5.041 5.041 0 0 0-4.01-4.937 5.083 5.083 0 0 0 .2-1.416 5.036 5.036 0 0 0-4.009-4.935 5.037 5.037 0 0 0-5.384-6.429l-9.6-1.818c-1.464-.278-3.293-.461-4.448.591a2.629 2.629 0 0 0-.22.228 5.062 5.062 0 0 0-5.311 1.168 5.008 5.008 0 0 0-1.475 3.568 5.09 5.09 0 0 0 .2 1.416 5.042 5.042 0 0 0-4.008 4.932 5.075 5.075 0 0 0 .2 1.42 5.047 5.047 0 0 0-3.129 7.789 5.044 5.044 0 0 0-1.94 8.345l.235.234-4.843 4.84a4.867 4.867 0 0 0-5.506.954l-2.573 2.566a4.863 4.863 0 0 0 0 6.867l3.211 3.207a1.456 1.456 0 0 0 2.057-2.06l-3.211-3.209a1.952 1.952 0 0 1 0-2.746l2.573-2.566a1.949 1.949 0 0 1 2.374-.291 1.469 1.469 0 0 0 .183.224 1.449 1.449 0 0 0 .418.291l14.756 14.733a1.434 1.434 0 0 0 .7.709 1.948 1.948 0 0 1-.081 2.658l-2.569 2.563a1.955 1.955 0 0 1-2.752 0l-3.211-3.2a1.456 1.456 0 0 0-2.058 2.058l3.213 3.214a4.874 4.874 0 0 0 6.864 0l2.572-2.569a4.867 4.867 0 0 0 .681-6.011l5.454-5.447.017-.018c.625-.646 2.364-.525 4.046-.408a20.935 20.935 0 0 0 3.829.025l5.973 5.966a4.865 4.865 0 0 0 .826 5.763l2.572 2.569a4.867 4.867 0 0 0 6.866 0l15.6-15.582a4.862 4.862 0 0 0 0-6.867zM34.588 85.229l6.314 1.2-3.779 3.771a9.176 9.176 0 0 1-2.265-1.646 6.7 6.7 0 0 1-2.142-3.309 1.272 1.272 0 0 1-.006-.143 4.932 4.932 0 0 1 1.879.127zm-7.38 1.187a2.147 2.147 0 0 1 2.716-.257 10.411 10.411 0 0 0 2.921 4.5 10.78 10.78 0 0 0 4.194 2.6 2.136 2.136 0 0 1-3.266 2.728l-6.564-6.553a2.143 2.143 0 0 1 0-3.017zm-3.8 6.352a2.147 2.147 0 0 1 3.025 0l5.286 5.275a2.139 2.139 0 0 1-3.028 3.023l-4.01-4.009-.019-.018-1.262-1.253a2.136 2.136 0 0 1 0-3.018zm-3.811 6.351a2.154 2.154 0 0 1 3.015-.01l4.022 4.02a2.136 2.136 0 0 1-3.027 3.016l-1.458-1.456-2.551-2.548a2.141 2.141 0 0 1 0-3.021zm-2.535 7.629a2.152 2.152 0 0 1 3.029 0l1.46 1.458a2.136 2.136 0 0 1-3.029 3.014l-.183-.182-.007-.007-.008-.008-1.261-1.256a2.138 2.138 0 0 1 0-3.019zm29.663 16.543a1.456 1.456 0 0 0-2.058 0l-1.3 1.293c-1.231 1.231-3.46 1.076-5.617.926-2.342-.163-4.763-.331-6.33 1.278l-5.361 5.355-13.405-13.389 4.745-4.736a5.048 5.048 0 0 0 7.684-4.3v-.038h.038a5.035 5.035 0 0 0 5.046-5.04v-.038h.033a5.029 5.029 0 0 0 5.046-5.079h.039a5.049 5.049 0 0 0 4.315-7.676l4.159-4.157a2.136 2.136 0 0 1 1.093-.582c.043 0 .086-.012.128-.02a2.133 2.133 0 0 1 1.812 3.62l-1.271 1.262-.013.012-1.458 1.456a1.456 1.456 0 0 0 2.057 2.06l1.272-1.27.192-.191a2.144 2.144 0 0 1 3.021.007 2.136 2.136 0 0 1 0 3.017l-1.274 1.276-1.462 1.453a1.456 1.456 0 0 0 2.054 2.063l1.465-1.459a2.136 2.136 0 0 1 3.023 3.019l-2.539 2.54a1.455 1.455 0 1 0 2.059 2.058l1.245-1.245.022-.02a2.136 2.136 0 0 1 3.024 3.019l-1.265 1.264-2.008 2.006a1.456 1.456 0 0 0 2.057 2.06l.982-.981 4.708 4.7-13.406 13.39-4.8-4.8a5.724 5.724 0 0 0 .956-.769l1.294-1.293a1.455 1.455 0 0 0 0-2.058zm24.437 1.8l-15.6 15.582a1.956 1.956 0 0 1-2.751 0l-2.572-2.569a1.946 1.946 0 0 1 0-2.743l15.6-15.582a1.956 1.956 0 0 1 2.752 0l2.571 2.564a1.951 1.951 0 0 1 0 2.747z"
              fill="#0072ce"
              data-name="Path 99"
              transform="translate(0 -70.279)"
            />
            <path
              id="prefix__Path_100"
              d="M87.455 10.524a1.456 1.456 0 0 0 2.056-2.061l-5.3-5.294a1.456 1.456 0 0 0-2.056 2.06z"
              fill="#0072ce"
              data-name="Path 100"
              transform="translate(-69.147 -2.348)"
            />
            <path
              id="prefix__Path_101"
              d="M373.107 10.95a1.452 1.452 0 0 0 1.029-.426l5.3-5.294a1.456 1.456 0 1 0-2.057-2.06l-5.3 5.294a1.455 1.455 0 0 0 1.029 2.485z"
              fill="#0072ce"
              data-name="Path 101"
              transform="translate(-317.17 -2.348)"
            />
            <path
              id="prefix__Path_102"
              d="M60.347 430.628a1.456 1.456 0 0 0 .018 2.058 1.456 1.456 0 1 0-.022-2.062z"
              fill="#0072ce"
              data-name="Path 102"
              transform="translate(-50.503 -368.016)"
            />
            <path
              id="prefix__Path_103"
              d="M333.969 335.03a1.456 1.456 0 1 0-.654-2.756h-.008a1.455 1.455 0 0 0 .662 2.752z"
              fill="#0072ce"
              data-name="Path 103"
              transform="translate(-283.686 -284.116)"
            />
          </g>
        </svg>
      )
    case 'Building':
      return (
        <svg
          data-testid="building-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="76.519"
          height="80.344"
          viewBox="0 0 76.519 80.344"
        >
          <g id="prefix__real-estate" transform="translate(-12.186)">
            <g
              id="prefix__Group_159"
              data-name="Group 159"
              transform="translate(48.948 9.044)"
            >
              <g id="prefix__Group_158" data-name="Group 158">
                <path
                  id="prefix__Path_160"
                  d="M252.42 57.633h-4.512a1.455 1.455 0 0 0-1.453 1.454V64.5a1.455 1.455 0 0 0 1.453 1.453h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.412a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 160"
                  transform="translate(-246.454 -57.633)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_161"
              data-name="Group 161"
              transform="translate(57.919 9.044)"
            >
              <g id="prefix__Group_160" data-name="Group 160">
                <path
                  id="prefix__Path_161"
                  d="M309.593 57.633h-4.513a1.455 1.455 0 0 0-1.453 1.454V64.5a1.455 1.455 0 0 0 1.453 1.453h4.512a1.455 1.455 0 0 0 1.453-1.454v-5.412a1.455 1.455 0 0 0-1.452-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 161"
                  transform="translate(-303.627 -57.633)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_163"
              data-name="Group 163"
              transform="translate(66.891 9.044)"
            >
              <g id="prefix__Group_162" data-name="Group 162">
                <path
                  id="prefix__Path_162"
                  d="M366.765 57.633h-4.512a1.455 1.455 0 0 0-1.453 1.454V64.5a1.455 1.455 0 0 0 1.453 1.453h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.412a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 162"
                  transform="translate(-360.799 -57.633)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_165"
              data-name="Group 165"
              transform="translate(48.948 22.49)"
            >
              <g id="prefix__Group_164" data-name="Group 164">
                <path
                  id="prefix__Path_163"
                  d="M252.42 143.318h-4.512a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.415a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 163"
                  transform="translate(-246.454 -143.318)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_167"
              data-name="Group 167"
              transform="translate(57.919 22.49)"
            >
              <g id="prefix__Group_166" data-name="Group 166">
                <path
                  id="prefix__Path_164"
                  d="M309.593 143.318h-4.513a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.453-1.454v-5.415a1.455 1.455 0 0 0-1.452-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 164"
                  transform="translate(-303.627 -143.318)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_169"
              data-name="Group 169"
              transform="translate(66.891 22.49)"
            >
              <g id="prefix__Group_168" data-name="Group 168">
                <path
                  id="prefix__Path_165"
                  d="M366.765 143.318h-4.512a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.415a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 165"
                  transform="translate(-360.799 -143.318)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_171"
              data-name="Group 171"
              transform="translate(48.948 35.936)"
            >
              <g id="prefix__Group_170" data-name="Group 170">
                <path
                  id="prefix__Path_166"
                  d="M252.42 229.005h-4.512a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.415a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828V231.3h2.828z"
                  fill="#0072ce"
                  data-name="Path 166"
                  transform="translate(-246.454 -229.005)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_173"
              data-name="Group 173"
              transform="translate(57.919 35.936)"
            >
              <g id="prefix__Group_172" data-name="Group 172">
                <path
                  id="prefix__Path_167"
                  d="M309.593 229.005h-4.513a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.453-1.454v-5.415a1.455 1.455 0 0 0-1.452-1.454zm-.842 6.026h-2.828V231.3h2.828z"
                  fill="#0072ce"
                  data-name="Path 167"
                  transform="translate(-303.627 -229.005)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_175"
              data-name="Group 175"
              transform="translate(66.891 35.936)"
            >
              <g id="prefix__Group_174" data-name="Group 174">
                <path
                  id="prefix__Path_168"
                  d="M366.765 229.005h-4.512a1.455 1.455 0 0 0-1.453 1.454v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.415a1.455 1.455 0 0 0-1.454-1.454zm-.842 6.026h-2.828V231.3h2.828z"
                  fill="#0072ce"
                  data-name="Path 168"
                  transform="translate(-360.799 -229.005)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_177"
              data-name="Group 177"
              transform="translate(66.891 49.382)"
            >
              <g id="prefix__Group_176" data-name="Group 176">
                <path
                  id="prefix__Path_169"
                  d="M366.765 314.692h-4.512a1.455 1.455 0 0 0-1.453 1.453v5.415a1.455 1.455 0 0 0 1.453 1.454h4.512a1.455 1.455 0 0 0 1.454-1.454v-5.415a1.455 1.455 0 0 0-1.454-1.453zm-.842 6.026h-2.828v-3.73h2.828z"
                  fill="#0072ce"
                  data-name="Path 169"
                  transform="translate(-360.799 -314.692)"
                />
              </g>
            </g>
            <g
              id="prefix__Group_179"
              data-name="Group 179"
              transform="translate(12.186)"
            >
              <g id="prefix__Group_178" data-name="Group 178">
                <path
                  id="prefix__Path_170"
                  d="M87.882 54.5a4.78 4.78 0 0 0-6.6-1.277l-3.156 2.112V5.957h.229a1.509 1.509 0 0 0 1.506-1.507V1.507A1.509 1.509 0 0 0 78.354 0h-7.33a1.148 1.148 0 0 0 0 2.3h6.541v1.361H45.338V2.3h18.5a1.148 1.148 0 1 0 0-2.3H44.55a1.509 1.509 0 0 0-1.507 1.507V4.45a1.509 1.509 0 0 0 1.507 1.507h.583V20.7h-2.357v-2.833a1.791 1.791 0 0 0-1.789-1.789h-8.666a1.791 1.791 0 0 0-1.789 1.789V20.7h-1.65a1.861 1.861 0 0 0-1.859 1.859v26.323q-.729-.046-1.461-.048h-1.809v-.6a4.043 4.043 0 0 0-4.039-4.034h-3.49a4.043 4.043 0 0 0-4.039 4.039v16.39a1.148 1.148 0 0 0 2.3 0V48.237a1.745 1.745 0 0 1 1.743-1.743h3.49a1.745 1.745 0 0 1 1.743 1.743v25.826a1.745 1.745 0 0 1-1.743 1.743h-3.49a1.745 1.745 0 0 1-1.743-1.743v-2.252a1.148 1.148 0 0 0-2.3 0v2.252a4.043 4.043 0 0 0 4.04 4.037h3.49a4.043 4.043 0 0 0 4.039-4.039V74l15.893 6.019q.047.018.095.031a7.663 7.663 0 0 0 2.088.3 7.2 7.2 0 0 0 1.121-.088l23.46-3.382h.017a11.548 11.548 0 0 0 5.472-2.46l.042-.036 15.164-13.638a4.781 4.781 0 0 0 .776-6.246zM47.428 5.957h28.4v50.912L66.28 63.26l-3.2-.18-.08-.82a7.014 7.014 0 0 0-.4-1.728q-.1-.273-.222-.535a6.949 6.949 0 0 0-1.719-2.297h3.226a1.455 1.455 0 0 0 1.453-1.454v-5.411a1.455 1.455 0 0 0-1.453-1.453h-4.512a1.455 1.455 0 0 0-1.453 1.453v5.389a7.094 7.094 0 0 0-.892-.186h-.029l-.631-.073v-5.13a1.455 1.455 0 0 0-1.454-1.454H50.4a1.455 1.455 0 0 0-1.453 1.454v4.273l-1.519-.175V5.957zm12.787 49.451v-3.73h2.828v3.73zm-6.144-3.73v3.73h-2.52l-.308-.035v-3.696zm-21.244-33.3h7.653V20.7h-7.653zM29.319 23h15.814v3.589H32.17a1.347 1.347 0 0 0-1.346 1.346V31.4a1.347 1.347 0 0 0 1.346 1.346h12.963v3.229H32.17a1.347 1.347 0 0 0-1.346 1.346v3.465a1.347 1.347 0 0 0 1.346 1.346h12.963v3.229H32.17a1.347 1.347 0 0 0-1.346 1.339v2.74q-.292-.068-.587-.128l-.278-.055-.327-.06c-.109-.019-.209-.039-.314-.056zm15.814 5.885v1.566H33.12v-1.57zm0 9.386v1.566H33.12v-1.57zM33.12 49.219v-1.566h12.013v1.566zm12.013 2.3v3.154l-.354-.041a20.9 20.9 0 0 1-2.191-.433 20.617 20.617 0 0 1-4.038-1.489q-.258-.127-.513-.262-.416-.219-.824-.457c-.2-.117-.4-.23-.605-.341l-.132-.071-.121-.065zm40.444 7.52L70.429 72.658a9.249 9.249 0 0 1-4.353 1.942l-23.46 3.382h-.032a5.148 5.148 0 0 1-2.174-.138l-16.657-6.301V51.13h1.809a20.735 20.735 0 0 1 2.483.152q.25.03.5.066l.072.011q.629.093 1.247.224c.128.027.257.054.384.084l.191.046c.166.04.333.082.5.126l.09.024A20.788 20.788 0 0 1 34.8 53.3l.108.054q.231.116.458.238l.139.074c.183.1.365.2.545.307h.008q.732.428 1.487.8a22.948 22.948 0 0 0 6.927 2.127h.03l1.648.19 1.342.155 3.095.356.768.089 5.365.618a4.675 4.675 0 0 1 3.993 4.174l.04.4-21.514-2.1a1.148 1.148 0 1 0-.223 2.285L61.822 65.3a1.123 1.123 0 0 0 .146.019l4.566.256h.064c.023 0 .045 0 .068-.005s.052 0 .078-.006.065-.011.1-.019.051-.01.076-.017.068-.024.1-.037.043-.015.063-.024a1.157 1.157 0 0 0 .155-.086l10.379-6.946 4.944-3.309a2.474 2.474 0 0 1 3.017 3.908z"
                  fill="#0072ce"
                  data-name="Path 170"
                  transform="translate(-12.186)"
                />
              </g>
            </g>
          </g>
        </svg>
      )
    case 'COH':
      return (
        <svg
          data-testid="coh-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 136.238 75"
        >
          <defs>
            <clipPath id="a">
              <path fill="none" d="M0 0h136.238v75H0z" />
            </clipPath>
          </defs>
          <g clipPath="url(#a)">
            <path
              d="M71.917 35.564c-4.776 0-7.994-3.683-7.994-9.127s3.272-9.168 8.095-9.168a8.527 8.527 0 014.958 1.5l-.283 1.801a7.92 7.92 0 00-4.722-1.713c-3.886 0-6.287 3.063-6.287 7.535s2.428 7.562 6.26 7.562a8.264 8.264 0 005.032-1.842l.256 1.686a9.161 9.161 0 01-5.4 1.767M81.132 20.237a1.228 1.228 0 111.228-1.228 1.228 1.228 0 01-1.228 1.228m-.857 2.907h1.659v12.078h-1.659zM90.016 35.435c-1.889 0-3.144-.742-3.144-2.968v-7.892h-1.875v-1.43h1.862v-4.19l1.659-.283v4.472h2.786l.229 1.43h-3.015v7.618c0 1.221.486 1.761 1.788 1.761a6.57 6.57 0 001.127-.128l.256 1.4a6.544 6.544 0 01-1.686.209M98.671 36.738c-.857 2.348-1.943 3.063-3.73 3.063a5.289 5.289 0 01-.675-.074l-.229-1.484a5.564 5.564 0 001 .1c1 0 1.585-.432 2.024-1.605l.56-1.457L93.092 23.3l1.639-.31 3.757 10.3 3.575-10.119h1.734zM108.846 25.978c-2.435 0-4.047 1.9-4.047 4.722s1.632 4.722 4.047 4.722 4.122-1.889 4.122-4.722-1.653-4.722-4.122-4.722m0 8.095c-1.545 0-2.55-1.349-2.55-3.373s.978-3.373 2.55-3.373 2.584 1.349 2.584 3.373-.968 3.368-2.584 3.368M115.043 24.177v1.99h-1.349v1.349h1.349v7.7h1.484v-7.734h2.078l-.216-1.349h-1.862v-1.848c0-.823.364-1.194 1.194-1.194 0 0 .108 0 .89.067l-.344-1.4c-.371-.04-.621-.054-.621-.054a2.3 2.3 0 00-2.6 2.5M76.262 57.36v-8.427H66.48v8.426h-1.767V39.733h1.767v7.616h9.781v-7.616h1.772V57.36zM87.024 57.616c-3.09 0-5.4-2.3-5.4-6.287s2.375-6.307 5.4-6.307c3.144 0 5.5 2.3 5.5 6.307s-2.4 6.287-5.5 6.287m0-11.164c-2.4 0-3.7 2.024-3.7 4.877s1.349 4.857 3.7 4.857 3.757-2.024 3.757-4.857-1.357-4.877-3.757-4.877M100.513 57.515a8.318 8.318 0 01-3.144-.587v4.823l-1.686.283V45.278h1.3l.283 1.734a5.073 5.073 0 013.906-2.024c2.631 0 4.857 1.916 4.857 5.95 0 4.425-2.584 6.543-5.518 6.543m.506-10.935c-1.43 0-2.53.836-3.629 2.165v6.672a6.591 6.591 0 003.123.7c2.172 0 3.859-1.659 3.859-5.032 0-2.941-1.4-4.52-3.319-4.52M118.618 51.437h-8.405c.054 2.961 1.43 4.722 3.859 4.722a6.543 6.543 0 004.27-1.788l.25 1.531a7.009 7.009 0 01-4.587 1.713c-3.171 0-5.444-2.145-5.444-6.307 0-3.886 2.253-6.287 5.214-6.287 3.292 0 4.877 2.7 4.877 6.071zm-4.877-5.055c-1.889 0-3.117 1.4-3.447 3.73h6.591c-.182-2.172-1.2-3.73-3.144-3.73M41.601 35.159c0-1.417 0-2.759.094-3.973a14.962 14.962 0 01.607-3.845 62.225 62.225 0 01-4.843-5.214c-1.268 1.444-2.961 3.258-4.864 5.066a15.057 15.057 0 01.749 3.994c.04.54.067 1.106.088 1.693a14.247 14.247 0 004.115 2.53 12.648 12.648 0 004.047-.25m-4.533-2.1a1.234 1.234 0 111.234 1.234 1.234 1.234 0 01-1.234-1.234m1.14 4.108a13.559 13.559 0 00-.047 4.587c.546 4.162 3.737 8.385 5.161 10.119a128.3 128.3 0 01-1.693-15.907c-1.032.411-2.206.83-3.42 1.187M17.64 57.34H57.4V17.6H17.64zm28.05-36.799a1.781 1.781 0 11-1.774 1.781 1.781 1.781 0 011.774-1.781m-16.338 0a1.781 1.781 0 11-1.781 1.781 1.781 1.781 0 011.781-1.781m26.268 3.744a34.087 34.087 0 01-10.058 3.98 19.428 19.428 0 00-.072 6.631c1.012 7.677 8.473 15.745 8.628 15.94.088.088 0 .229-.094.169a33.513 33.513 0 01-9.727-10.53 111.457 111.457 0 00-.169 14.5c0 .189-.175.155-.2.068-.088-.3-.277-1.248-.519-2.617a22.362 22.362 0 01-6.064-6.816 75.555 75.555 0 00-.088 10.011c0 .135-.148.128-.169.067-.27-.951-2.024-10.793-1.545-16.507a10.477 10.477 0 01.5-2.752c-.958-.917-1.842-1.835-2.6-2.658a119.82 119.82 0 01-2.341 21.276c0 .088-.216.121-.2-.067a111.46 111.46 0 00-.169-14.5 33.513 33.513 0 01-9.72 10.53c-.094.061-.182-.081-.094-.169.2-.2 7.616-8.264 8.628-15.954a19.428 19.428 0 00-.067-6.631 64.26 64.26 0 01-10.051-3.967c-.1-.047-.081-.223.088-.182 1.059.317 7.272 2.206 10.908 1.632 2.091-.641 4.661-2.563 6.577-4.169-.843-1.032-1.43-1.815-1.68-2.152-.088-.1 0-.243.135-.142.3.277 1.052 1 2.024 1.869 1.005-.87 1.774-1.585 2.084-1.869.108-.1.216.04.135.142-.256.344-.877 1.106-1.761 2.132 1.923 1.639 4.526 3.636 6.645 4.29 3.629.6 9.856-1.417 10.915-1.747.169-.04.2.135.094.182M122.518 57.61a1.862 1.862 0 01-1.943-1.983 1.943 1.943 0 111.943 1.983m0-3.744a1.761 1.761 0 101.666 1.761 1.612 1.612 0 00-1.666-1.761m.567 2.82l-.675-.938h-.216v.917h-.378v-2.206h.675c.459 0 .769.229.769.634a.587.587 0 01-.445.607l.634.9zm-.58-1.889h-.29v.675h.27c.25 0 .4-.1.4-.324s-.135-.324-.385-.324"
              className="c"
            />
          </g>
        </svg>
      )
    case 'Alert':
      return (
        <svg
          width="20px"
          height="auto"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          viewBox="0 0 55.88 48.4"
        >
          <defs />
          <path d="M27.94 0L0 48.39h55.88zm-1.67 17.78h3.4v13h-3.4zm1.69 22.59a2.49 2.49 0 01-1.81-.72 2.55 2.55 0 01-.75-1.8 2.64 2.64 0 01.73-1.81 2.68 2.68 0 013.62 0 2.64 2.64 0 01.73 1.81 2.53 2.53 0 01-2.55 2.55z" />
        </svg>
      )
    case 'Custom Icon':
      return (
        <StyledSvgContainer>
          <StyledSvg
            alt="custom-icon"
            imgStyle={{ objectFit: 'contain' }}
            fluid={customIcon?.fluid || createFluidObj(customIcon?.file?.url)}
            height="auto"
            width={width || '75px'}
            {...props}
          />
        </StyledSvgContainer>
      )
    default:
      return <div></div>
  }
}

Icon.propTypes = {
  icon: PropTypes.oneOf(['Support', 'Building', 'COH', 'Custom Icon']),
}
export default Icon
